import React from 'react';
import { FadeUp } from './ui/FadeUp';
export function FinalCTASection() {
  return <section className="py-28 bg-section-lavender" data-id="element-51">
      <div className="max-w-[1240px] mx-auto px-8 text-center" data-id="element-52">
        <FadeUp data-id="element-53">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-54">
            Ready to get HR off your plate?
          </h2>
          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-55">
            SparkHR helps growing teams stay compliant, organized, and supported
            without building a full HR department.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-56">
            <a href="https://calendly.com/krystina-joinsparkhr/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-gradient-primary rounded-full hover:shadow-lg hover:opacity-90 transition-all duration-300 w-full sm:w-auto" data-id="element-57">
              Book an Intro Call
            </a>
            <a href="#start-here" className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-gray-700 bg-white border border-[#eee] rounded-full hover:bg-gray-50 transition-colors w-full sm:w-auto" data-id="element-58">
              Or, tell us what's going on
            </a>
          </div>
        </FadeUp>
      </div>
    </section>;
}